import Axios from 'axios';
import { NextRouter } from 'next/router';

export function error_handler(
  error: unknown,
  router: NextRouter
): { unknown_error: unknown | null; message: string | null } {
  if (Axios.isAxiosError(error)) {
    if (error.response?.status === 400) {
      if (error.response?.data.error_code === 101) {
        router.push('/users/self/create');
        return { message: '転送中...', unknown_error: null };
      }
      if (error.response?.data.error_code === 102) {
        router.push('/account/settings');
        return { message: '転送中...', unknown_error: null };
      }
      if (error.response?.data.error_code === 126) {
        return {
          message: '会社情報の削除に失敗しました。サポートまでご連絡ください。',
          unknown_error: null,
        };
      }
      if (error.response?.data.error_code === 127) {
        return {
          message:
            '進行中の注文があるため、退会処理に失敗しました。注文完了後に再度お試しいただくか、サポートまでご連絡ください。',
          unknown_error: null,
        };
      }
    }
    if (error.response?.status === 401) {
      return {
        message:
          '認証中。しばらく経っても切り替わらない場合は画面を更新してください。',
        unknown_error: null,
      };
    }
    if (error.response?.status === 404) {
      return {
        message: 'ページが見つかりませんでした。',
        unknown_error: null,
      };
    }
    if (error.response?.status === 415) {
      if (error.response?.data.error_code === 123) {
        return {
          message:
            'サポートされていないファイル形式です。画像をJPEG形式で再出力すると解決する場合があります。解決しない場合はお問い合わせください。',
          unknown_error: null,
        };
      }
      return {
        message: 'サポートされていないファイル形式です。',
        unknown_error: null,
      };
    }
  }
  if (error === 'No current user') {
    return {
      message: 'セッションが切れた可能性があります。画面を更新してください。',
      unknown_error: null,
    };
  }
  return { unknown_error: error, message: null };
}

export function check_unknown(
  error: unknown,
  status: number,
  error_code: number
) {
  if (Axios.isAxiosError(error)) {
    return (
      error.response?.status === status &&
      error.response?.data.error_code === error_code
    );
  }
  return false;
}

export function catch_and_alert(e: unknown, router: NextRouter) {
  const error = error_handler(e, router);
  if (error.message) {
    alert(error.message);
  } else {
    alert('不明なエラー');
  }
}
